import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  getUserTransmissionProgressAnalytics,
  getUserTransmissionProgressReport,
  getTransmissionProgressAnalyticsUsers,
} from "app/services/userActivityLog/userActivityLog.service";
import { BASE_URL } from "static/constants";

export const userActivityLogApi = createApi({
  reducerPath: "userActivityLogApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({
    getUserTransmissionProgressAnalytics: builder.query({
      queryFn: ({ users, startDate, endDate }) => ({
        data: getUserTransmissionProgressAnalytics({
          users: users?.join(","),
          startDate,
          endDate,
        }),
      }),
    }),
    getUserTransmissionProgressReport: builder.mutation({
      queryFn: async ({ users, startDate, endDate }) => {
        const response = await getUserTransmissionProgressReport({
          users: users,
          startDate,
          endDate,
        });
        return { data: response };
      },
    }),
    getTransmissionProgressAnalyticsUsers: builder.query({
      queryFn: () => ({
        data: getTransmissionProgressAnalyticsUsers(),
      }),
    }),
  }),
});

export const {
  useGetUserTransmissionProgressAnalyticsQuery,
  useGetUserTransmissionProgressReportMutation,
  useGetTransmissionProgressAnalyticsUsersQuery,
} = userActivityLogApi;
